module.exports = __webpack_public_path__ + "img/rays-sm.881ab6f9.png";